import React from 'react';
import { getAvatarInitials } from 'fym-shared/src/avatars/getAvatarInitials';
import { TypedMemo } from '../../../common/types';
import styles from './SMLInitialsAvatar.module.scss';

interface SMLInitialsAvatarProps {
  name: string;
  /** Display width in CSS pixels. Sets the size of the initials. */
  width?: number;
  className?: string;
  style?: React.CSSProperties;
}

// The initials take 40% of the avatar width.
const INITIALS_TO_WIDTH_RATIO = 0.4;

/** Stands in for an entity that has no image: its initials on the brand tint. */
const SMLInitialsAvatarComponent: React.FC<SMLInitialsAvatarProps> = ({ name, width, className, style }) => (
  <span
    role="img"
    aria-label={name}
    className={`${styles.avatar} d-inline-flex align-items-center justify-content-center fw-semibold ${className ?? ''}`}
    style={width !== undefined ? { fontSize: Math.round(width * INITIALS_TO_WIDTH_RATIO), ...style } : style}
  >
    {getAvatarInitials(name)}
  </span>
);

export const SMLInitialsAvatar = TypedMemo(SMLInitialsAvatarComponent);
